module.exports = __webpack_public_path__ + "img/sanja-jasprica.0fa4ba0e.jpg";